import React, { useState } from "react";
import "@chatscope/chat-ui-kit-styles/dist/default/styles.min.css"
import {
    ChatContainer,
    MainContainer,
    Message, MessageGroup,
    MessageInput,
    MessageList,
    TypingIndicator
} from "@chatscope/chat-ui-kit-react";
import {Card, CardContent, CardDescription, CardHeader, CardTitle} from "../ui/Card";
import {Download, FileText} from "lucide-react";
import {Button} from "../ui/Button";
import OpenAI from "openai";
import {MessageDirection} from "@chatscope/use-chat";
import pzDataJSON from "../../data/pzData.json";

// const API_KEY = "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"
//const API_KEY="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"
const API_KEY="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"

const Chat = () => {
    const [typing, setTyping] = useState(false);
    const [messages, setMessages] = useState([]);

    // const handleSend = async (message) => {
    //     const newMessage = {
    //         message: message,
    //         sender: message.sender,
    //         direction: message.sender === "user" ? MessageDirection.Outgoing : MessageDirection.Incoming
    //     }
    //
    //     const newMessages = [...messages, newMessage];
    //     setMessages(newMessages);
    //
    //     setTyping(true);
    //
    //     await processMessageToChatGPT(newMessages)
    // }
    //
    // async function processMessageToChatGPT(chatMessages) {
    //     let apiMessage = chatMessages.map((messageObject) => {
    //         let role = ""
    //         if (messageObject.sender === "ChatGPT") {
    //             role = "assistant"
    //         } else {
    //             role = "user"
    //         }
    //         return {role: role, content: messageObject.message}
    //     })
    //
    //     const systemMessage = {
    //         role: "assistant",
    //         content: "Explain all concepts like I am 10 years old"
    //     }
    //
    //     const apiRequestBody = {
    //         "model": "gpt-3.5-turbo",
    //         "messages": [
    //             systemMessage,
    //             ...apiMessage
    //         ]
    //     }
    //
    //     await fetch("https://api.openai.com/v1/chat/completions", {
    //         method: "POST",
    //         headers: {
    //             "Authorization": `Bearer ${API_KEY}`,
    //             "Content-Type": "application/json",
    //         },
    //         body: JSON.stringify(apiRequestBody)
    //     }).then((data) => {
    //         return data.json();
    //     }).then(data => {
    //         console.log(data)
    //         if (data) {
    //             setMessages([...chatMessages, {
    //                 message: data.choices[0].message.content,
    //                 sender: "ChatGPT",
    //             }])
    //             setTyping(false);
    //         }
    //
    //     }).catch((e) => {
    //         console.error(e)
    //     })
    // }

    const handleSend = async (query) => {
        const apiKey = API_KEY;
        const apiUrl = "https://api.openai.com/v1/chat/completions";

        const userMessage = { sender: "user", direction: "outgoing", message: query };
        setMessages((prev) => [...prev, userMessage]);
        setTyping(true);

        const messagesPayload = [
            { role: "system", content: `You are a chatbot that only answers based on the following data: ${JSON.stringify(pzDataJSON)}` },
            { role: "user", content: query }
        ];

        try {
            const res = await fetch(apiUrl, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    Authorization: `Bearer ${apiKey}`,
                },
                body: JSON.stringify({
                    model: "gpt-4",
                    messages: messagesPayload,
                }),
            });

            const data = await res.json();
            const botMessage = {
                sender: "bot",
                direction: "incoming",
                message: data.choices[0]?.message?.content || "No response from ChatGPT.",
            };
            setMessages((prev) => [...prev, botMessage]);
            setTyping(false);

        } catch (error) {
            setMessages((prev) => [...prev, { sender: "bot", direction: "incoming", message: "Error fetching response." }]);
        }
    };

    return (
        <div className="grid grid-cols-3 gap-8">
            <Card>
                <CardHeader className="border-b border-black border-dotted">
                    <CardTitle className="text-black">Sources</CardTitle>
                </CardHeader>
                <CardContent>
                    <div className="relative w-full pt-4">
                        <CardDescription className="uppercase">See all sources</CardDescription>
                        <div className="flex items-center justify-between cursor-pointer hover:underline bg-gray-100 rounded-lg">
                            <div className="flex items-center gap-4 pl-4">
                                <FileText className="size-4 text-red-900"/>
                                <p className="mt-2">Report 150220251439.pdf</p>
                            </div>
                            <Button variant="icon">
                                <Download className="size-4" />
                            </Button>
                        </div>
                    </div>
                </CardContent>
            </Card>
            <Card className="col-span-2">
                <CardHeader className="border-b border-black border-dotted">
                    <CardTitle className="text-black">Chat</CardTitle>
                </CardHeader>
                <CardContent>
                    <div className="relative w-full pt-2 h-[700px]">
                        <MainContainer className="rounded-lg">
                            <ChatContainer>
                                <MessageList typingIndicator={typing ? <TypingIndicator content="AI Assistant is typing..."/> : null}>
                                    {messages.map((msg, index) => (
                                        <Message key={index} model={msg}/>
                                    ))}
                                </MessageList>
                                <MessageInput placeholder="Ask about anything piezometer..." onSend={handleSend}/>
                            </ChatContainer>
                        </MainContainer>
                    </div>
                </CardContent>
            </Card>
            {/*<Card>*/}
            {/*    <CardHeader className="border-b border-black border-dotted">*/}
            {/*        <CardTitle className="text-black">Studio</CardTitle>*/}
            {/*    </CardHeader>*/}
            {/*    <CardContent>*/}
            {/*        <div className="relative w-full h-full">*/}
            {/*            <MainContainer>*/}
            {/*                <ChatContainer>*/}
            {/*                    <MessageList typingIndicator={typing ?*/}
            {/*                        <TypingIndicator content="AI Assistant is typing..."/> : null}>*/}
            {/*                        {messages.map((message, index) => {*/}
            {/*                            return <Message key={index} model={message}/>;*/}
            {/*                        })}*/}
            {/*                    </MessageList>*/}
            {/*                    <MessageInput placeholder="Enter message" onSend={handleSend}/>*/}
            {/*                </ChatContainer>*/}
            {/*            </MainContainer>*/}
            {/*        </div>*/}
            {/*    </CardContent>*/}
            {/*</Card>*/}
        </div>
    );
};

export default Chat;
